import { createSlice } from '@reduxjs/toolkit';
import { getMasterBrands, getBrands, getBrandsPag, getBrandsPagCount,  } from './thunks';

const initialState = {
  list: {
    pageIndex: 0,
    totalRecords: 50,
    totalPages: 1,
    hasPreviousPage: false,
    hasNextPage: false,
    elements: [],
  },
  loading: 'idle',
  loadingCount: 'idle',
  loadingBrands: 'idle',
  brands: [],
  error: null,
};

const brandSlice = createSlice({
  name: 'brands',
  initialState,
  reducers: {
    clearBrandError: (state) => {
      state.error = null;
    },
    setBrandFilters: (state, action) => {
      state.filters = action.payload;
    },
  },
  extraReducers: {
    [getBrandsPag.pending]: (state) => {
      state.loading = 'loading';
      state.error = null;
    },
    [getBrandsPag.fulfilled]: (state, action) => {
      state.loading = 'succeeded';
      state.list.elements = action.payload.elements;
    },
    [getBrandsPag.rejected]: (state, action) => {
      state.loading = 'failed';
      state.error = action.error.message;
    },
    [getBrandsPagCount.pending]: (state) => {
      state.loadingCount = 'loading';
      state.error = null;
    },
    [getBrandsPagCount.fulfilled]: (state, action) => {
      state.loadingCount = 'succeeded';
      state.list.pageIndex = action.payload.pageIndex;
      state.list.totalRecords = action.payload.totalRecords;
      state.list.totalPages = action.payload.totalPages;
      state.list.hasPreviousPage = action.payload.hasPreviousPage;
      state.list.hasNextPage = action.payload.hasNextPage;
    },
    [getBrandsPagCount.rejected]: (state, action) => {
      state.loadingCount = 'failed';
      state.error = action.error.message;
    },
    [getMasterBrands.pending]: (state) => {
      state.loadingBrands = 'loading';
      state.error = null;
    },
    [getMasterBrands.fulfilled]: (state, action) => {
      state.brands = action.payload;
      state.loadingBrands = 'succeeded';
    },
    [getMasterBrands.rejected]: (state, action) => {
      state.loadingBrands = 'failed';
      state.error = action.error.message;
    },
    [getBrands.pending]: (state) => {
      state.loadingBrands = 'loading';
      state.error = null;
    },
    [getBrands.fulfilled]: (state, action) => {
      state.brands = action.payload;
      state.loadingBrands = 'succeeded';
    },
    [getBrands.rejected]: (state, action) => {
      state.loadingBrands = 'failed';
      state.error = action.error.message;
    },
  },
});

export const { clearBrandError: clearBrandError, setBrandFilters: setBrandFilters } = brandSlice.actions;

export default brandSlice.reducer;
